import { MemoryRouter, Routes, Route } from 'react-router-dom';
import { Providers } from '@/shell/Providers';
import { AppShell } from '@/shell/AppShell';
import { Login } from '@/auth/Login';
import { Signup } from '@/auth/Signup';

export default function App() {
  return (
    <MemoryRouter initialEntries={['/instaflix']}>
      <Providers>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/*" element={<AppShell />} />
        </Routes>
      </Providers>
    </MemoryRouter>
  );
}
